import { microActivityList, microActivityUniqueList } from "constants/microActivity";

const initialState = {
  microActivityList: {},
  microActivityUniqueList: {},
};

const microActivity = (state = initialState, action) => {
  switch (action.type) {
    case microActivityList:
      return { ...state, microActivityList: action.payload };

    case microActivityUniqueList:
      return { ...state, microActivityUniqueList: action.payload };

    default:
      return state;
  }
};
export default microActivity;
